import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import type {Block} from '@/services/kontent-ai/types'
import {ButtonIcons} from '@/components/button-icons/button-icon'
import {Button} from '@/products/flexible-web-toolkit/components/button/button'
import type {CtaButtonContentItem} from '@/products/flexible-web-toolkit/blocks/cta-button'
import {GridCards} from '@/products/flexible-web-toolkit/components/grid-cards'

type FactBlockContentItem = IContentItem<{
	title: Elements.TextElement
	subTitle: Elements.TextElement
}>

export type FactListerBlockContentItem = IContentItem<{
	title: Elements.TextElement
	body: Elements.RichTextElement
	ctaButton: Elements.LinkedItemsElement<CtaButtonContentItem>
	factsList: Elements.LinkedItemsElement<FactBlockContentItem>
}>

export const FactListerBlock: Block<FactListerBlockContentItem> = ({
	block: {
		elements: {
			factsList,
			title,
			body: {value},
			ctaButton,
		},
	},
}) => {
	const facts = factsList.map((fact) => ({
		title: fact.elements.title,
		sub_title: fact.elements.subTitle,
	}))

	return (
		<div className="container mt-16 md:flex md:items-center">
			<div className="md:w-1/2">
				<GridCards col={5}>
					{facts.map((fact) => (
						<div
							className="factBlock flex h-36 w-full items-center
				rounded bg-gray-200 leading-normal md:h-44 md:w-44"
							key={fact.title}
						>
							<div className="p-20px m-auto flex flex-col text-center">
								<h1 className="mb-1">{fact.title}</h1>
								<h4 className="font-light">{fact.sub_title}</h4>
							</div>
						</div>
					))}
				</GridCards>
			</div>
			<div className="my-8 md:mx-8 md:w-1/2">
				<div className="content">
					<h3>{title}</h3>
					<div dangerouslySetInnerHTML={{__html: value}} />
				</div>
				{ctaButton[0] ? (
					<Button
						className="text-base"
						href={ctaButton[0].elements.url}
						icon={ButtonIcons.External}
					>
						{ctaButton[0].elements.text}
					</Button>
				) : null}
			</div>
		</div>
	)
}
